import HomePage from "./components/HomePage/HomePage";

export default function App() {
  return <HomePage />;
}
